import type { ReactElement } from 'react';

import { useConfigSlice } from '../../../store/slices/config/selectors';
import { TableClosedConnected } from '../content/TableClosedConnected';
import { Popup } from '../Popup';

export const TableClosedPopupConnected = (): ReactElement | null => {
  const tableConfig = useConfigSlice.tableConfig();
  if (tableConfig?.tableClosed) {
    const content = <TableClosedConnected />;
    return (
      <div style={{ zIndex: 99999, position: 'absolute' }}>
        <Popup content={content} headerLess={true} handleClose={() => {}} />
      </div>
    );
  }
  return null;
};
